<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-12 has-text-centered">
      <brokers-list
          :brokers="brokers"
          :pagination="pagination"
          :getBrokers="getBrokerList"
          :isLoading="isLoading"
        />
    </div>
    <modal-component
      :active="isModalOpen"
      @cancel="cancel"
      titleModal="Nuevo asesor"
      optionalText="Registra los datos del asesor que tendrá acceso a la plataforma."
      @hdlOnClick="save"
      :loading="isLoading"
      :loader="isLoading"
      :scrollBody="false"
      textSave="Crear asesor"
    >
      <form class="columns is-multiline">
        <div class="column is-6">
          <label class="label" for="firstname">Nombre</label>
          <div class="control">
            <input
              id="firstname"
              class="input"
              type="text"
              placeholder="Nombre"
              name="firstname"
              v-model="broker.firstName"
              v-validate="'required'"
              :class="{'is-danger': vverrors.has('firstname')}"
              data-vv-as="Nombre"
            />
          </div>
          <p class="help is-danger">{{ vverrors.first('firstname') }}</p>
        </div>
        <div class="column is-6">
          <label class="label" for="secondname">Segundo nombre</label>
          <div class="control">
            <input
              id="secondname"
              class="input"
              type="text"
              placeholder="Segundo nombre"
              name="secondname"
              v-model="broker.secondName"
            />
          </div>
        </div>
        <div class="column is-6">
          <label class="label" for="lastname">Primer apellido</label>
          <div class="control">
            <input
              id="lastname"
              class="input"
              type="text"
              placeholder="Primer apellido"
              name="lastname"
              v-validate="'required'"
              v-model="broker.lastName"
              :class="{'is-danger': vverrors.has('lastname')}"
              data-vv-as="Primer apellido"
            />
          </div>
          <p class="help is-danger">{{ vverrors.first('lastname') }}</p>
        </div>
        <div class="column is-6">
          <label class="label" for="secondlastname">Segundo apellido</label>
          <div class="control">
            <input
              id="secondlastname"
              class="input"
              type="text"
              placeholder="Segundo apellido"
              name="secondlastname"
              v-model="broker.secondLastName"
            />
          </div>
        </div>
        <div class="column is-12">
          <label class="label" for="broker-email">Correo electrónico</label>
          <div class="control">
            <input
              id="broker-email"
              class="input"
              type="email"
              placeholder="Correo electrónico"
              name="email"
              autocomplete="off"
              v-validate="'required|email'"
              v-model="broker.email"
              :class="{'is-danger': vverrors.has('email')}"
              data-vv-as="Correo electrónico"
            />
          </div>
          <p class="help is-danger">{{ vverrors.first('email') }}</p>
        </div>
      </form>
    </modal-component>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  name: 'Consultants',
  mixins: [mixins],
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent'),
    BrokersList: () => import('@/components/Brokers/BrokersList.vue')
  },
  data () {
    return {
      isLoading: false,
      pagination: {
        pageNumber: 1
      },
      brokers: [],
      broker: {
        email: '',
        firstName: '',
        secondName: '',
        lastName: '',
        secondLastName: ''
      },
      isModalOpen: false,
      isSent: false,
      enableAddBrokers: false
    }
  },
  mounted () {
    this.getBrokerList()
    if (this.roleCode === 'custom') {
      this.hasCustomRoleAccess()
    }
  },
  methods: {
    ...mapActions(['getBrokers', 'saveBroker', 'getServicePermission']),
    emitTitleAction () {
      this.$emit('update-title-action', {
        label: 'Nuevo asesor',
        visible: this.hasBrokerAddAccess,
        disabled: false,
        handler: this.openCreateModal
      })
    },
    openCreateModal () {
      if (this.hasBrokerAddAccess) {
        this.isModalOpen = true
      }
    },
    getBrokerList (page) {
      this.isLoading = true
      this.getBrokers({ pageNumber: page, perPage: 10, order: { createdAt: 'DESC' } })
        .then(({ brokers, pagination }) => {
          this.brokers = brokers
          this.pagination = pagination
          this.isLoading = false
        })
    },
    async save () {
      if (await this.$validator.validateAll()) {
        this.isLoading = true
        const responseStatus = await this.saveBroker(this.broker)
        if (responseStatus) {
          await this.getBrokerList(0)
        }
        this.broker = {
          email: '',
          firstName: '',
          secondName: '',
          lastName: '',
          secondLastName: ''
        }
        this.isLoading = false
        this.isModalOpen = false
      }
    },
    cancel () {
      this.isModalOpen = false
      this.broker = {
        email: '',
        firstName: '',
        secondName: '',
        lastName: '',
        secondLastName: ''
      }
    },
    async hasCustomRoleAccess () {
      const resp = await this.getServicePermission(['saveBroker'])
      const filter = resp.filter(service => service.enabled).map(service => service.code)
      this.enableAddBrokers = filter.includes('saveBroker')
      this.emitTitleAction()
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      roleCode: state => state.financialCompany?.role?.code || ''
    }),
    hasBrokerAddAccess () {
      const adminRoles = ['admin', 'manager', 'compliance']
      return adminRoles.includes(this.roleCode) || this.enableAddBrokers
    }
  },
  watch: {
    roleCode (newValue) {
      if (newValue === 'custom') {
        this.hasCustomRoleAccess()
      } else {
        this.enableAddBrokers = false
        this.emitTitleAction()
      }
    },
    hasBrokerAddAccess () {
      this.emitTitleAction()
    }
  },
  created () {
    this.emitTitleAction()
  }
}
</script>
